<template>
	<div class="statusmask" v-if="dataVal.flag">
		<div
			:class="['contstatus', dataVal.status == 1 ? 'contstatus1' : dataVal.status == 2 ? 'contstatus2' : dataVal.status == 3 ? 'contstatus3' : '']">
			<img src="@/assets/image/tip/success.png" mode="" v-if="dataVal.status == 1" />
			<img src="@/assets/image/tip/fail.png" mode="" v-else-if="dataVal.status == 2" />
			<img src="@/assets/image/tip/wait.png" mode="" v-else-if="dataVal.status == 3" />
			<div>{{ dataVal.text }}</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		//是否显示
		dataVal: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {

		}
	},
	onLoad() {

	},
	methods: {
		handleRefund() {
			this.$emit("statusCall", {
				submitFlag: false
			})
		},
	},
	watch: {
		dataVal: {
			handler(newVal, oldVal) {
				if (newVal.flag) {
					let timer = setTimeout(() => {
						this.handleRefund()
						clearTimeout(timer)
					}, 2000)
				}
			},
			deep: true
		}
	}
}
</script>

<style lang="less" scoped>
.statusmask {
	width: 100vw;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0);
	z-index: 9999;

	.contstatus {
		min-width: 240px;
		min-height: 240px;
		border-radius: 16px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 32px;

		img {
			width: 72px;
			height: 72px;
		}

		div {
			height: 40px;
			line-height: 40px;
			font-size: 28px;
			color: #fff;
			margin-top: 16px;
		}
	}

	.contstatus1 {
		background-color: #07C160;
	}

	.contstatus2 {
		background-color: #EE0A24;
	}

	.contstatus3 {
		background-color: #FF976A;
	}
}
</style>